import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { RequirementsCount } from './RequirementsCount';

export class RequirementsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [RequirementsCount];
  }

  get title() {
    return terminology('Requirements');
  }
}
